// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EOINZ","rootNoMargin":"styles_rootNoMargin__3hMnw"};